import { Action } from '@ngrx/store';
import { Contract, Agreement, ContractsRequest, ContractIntervalRequest, ContractSettings, AdditionEsignData, AgreementAdditionExclusion } from '@model';
import { AdditionCodes } from '@enums';

export enum ContractsActionTypes {
  ContractLoadData = '[Contracts] Load contract',
  ContractLoadDataSuccess = '[Contracts] Load contract success',
  ContractLoadDataFail = '[Contracts] Load contract fail',

  ContractForDateIntervalLoadData = '[Contracts] Load contract for date interval',
  ContractForDateIntervalLoadDataSuccess = '[Contracts] Load contract for date interval success',
  ContractForDateIntervalLoadDataFail = '[Contracts] Load contract for date interval fail',

  ContractSetSelected = '[Contracts] Set loaded contract as selected',
  PrognosisContractSetSelected = '[Contracts] Set loaded contract for prognosis as selected',
  SelectTabIndexContract = '[Contracts] Select Tabindex for contract',

  ContractsLoadData = '[Contracts] Load contracts',
  ContractsLoadDataSuccess = '[Contracts] Load contracts success',
  ContractsLoadDataFail = '[Contracts] Load contracts fail',

  ContractsFilterSaveData = '[Contracts] Save contracts',

  AgreementProductsLoadData = '[Contracts] Load agreement products',
  AgreementProductsLoadDataSuccess = '[Contracts] Load agreement products success',
  AgreementProductsLoadDataFail = '[Contracts] Load agreement products fail',

  AgreementAdditionProductExclusionsLoadData = '[Contracts] Load agreement addition exclusions',
  AgreementAdditionProductExclusionsLoadDataSuccess = '[Contracts] Load agreement addition exclusions success',
  AgreementAdditionProductExclusionsLoadDataFail = '[Contracts] Load agreement addition exclusions fail',

  ContractClearData = '[Contracts] Clear contract',

  ContractTabChanged = '[Contracts] Tab changed',
  ContractSelectedColdPageIndex = '[Contracts] Set selected page index cold',
  ContractSelectedHotPageIndex = '[Contracts] Set selected page index hot',

  HasContractAdditions = '[Contracts] Has ContractAdditions',
  HasContractAdditionsSuccess = '[Contracts] Has ContractAdditions success',
  HasContractAdditionsFail = '[Contracts] Has ContractAdditions fail',

  AgreementAdditionEsignLoad = '[Contracts] Load addition e-sign details',
  AgreementAdditionEsignLoadSuccess = '[Contracts] Load addition e-sign details success',
  AgreementAdditionEsignLoadFail = '[Contracts] Load addition e-sign details fail',
}

// Contract
export class ContractLoad implements Action {
  readonly type = ContractsActionTypes.ContractLoadData;
  constructor(public payload: number) {}
}
export class ContractLoadSuccess implements Action {
  readonly type = ContractsActionTypes.ContractLoadDataSuccess;
  constructor(public payload: Contract) {}
}
export class ContractLoadFail implements Action {
  readonly type = ContractsActionTypes.ContractLoadDataFail;
  constructor(public payload: any) {}
}

export class ContractForDateIntervalLoad implements Action {
  readonly type = ContractsActionTypes.ContractForDateIntervalLoadData;
 constructor(public payload: ContractIntervalRequest) {}
}
export class ContractForDateIntervalLoadSuccess implements Action {
  readonly type = ContractsActionTypes.ContractForDateIntervalLoadDataSuccess;
  constructor(public payload: Contract[]) {}
}
export class ContractForDateIntervalLoadFail implements Action {
  readonly type = ContractsActionTypes.ContractForDateIntervalLoadDataFail;
  constructor(public payload: any) {}
}

export class ContractSetLoadedAsSelected implements Action {
  readonly type = ContractsActionTypes.ContractSetSelected;
  constructor(public payload: number) {}
}

export class PrognosisContractSetLoadedAsSelected implements Action {
  readonly type = ContractsActionTypes.PrognosisContractSetSelected;
  constructor(public payload: number) {}
}

export class SelectTabIndexContract implements Action{
  readonly type = ContractsActionTypes.SelectTabIndexContract;
  constructor(public payload: number){}
}

// Contracts
export class ContractsLoad implements Action {
  readonly type = ContractsActionTypes.ContractsLoadData;
  constructor(public payload: ContractsRequest) {}
}
export class ContractsLoadSuccess implements Action {
  readonly type = ContractsActionTypes.ContractsLoadDataSuccess;
  constructor(public payload: Contract[]) {}
}
export class ContractsLoadFail implements Action {
  readonly type = ContractsActionTypes.ContractsLoadDataFail;
  constructor(public payload: any) {}
}

// Contracts filter
export class ContractsFilterSave implements Action {
  readonly type = ContractsActionTypes.ContractsFilterSaveData;
  constructor(public payload: ContractSettings) {}
}


// Agreement products
export class AgreementProductsLoad implements Action {
  readonly type = ContractsActionTypes.AgreementProductsLoadData;
  constructor() {}
}

export class AgreementProductsLoadSuccess implements Action {
  readonly type = ContractsActionTypes.AgreementProductsLoadDataSuccess;
  constructor(public payload: Agreement[]) {}
}

export class AgreementProductsLoadFail implements Action {
  readonly type = ContractsActionTypes.AgreementProductsLoadDataFail;
  constructor(public payload: any) {}
}

// Agreement addition products - exclusions
export class AgreementAdditionProductExclusionsLoad implements Action {
  readonly type = ContractsActionTypes.AgreementAdditionProductExclusionsLoadData;
  constructor() {}
}

export class AgreementAdditionProductExclusionsLoadSuccess implements Action {
  readonly type = ContractsActionTypes.AgreementAdditionProductExclusionsLoadDataSuccess;
  constructor(public payload: AgreementAdditionExclusion[]) {}
}

export class AgreementAdditionProductExclusionsLoadFail implements Action {
  readonly type = ContractsActionTypes.AgreementAdditionProductExclusionsLoadDataFail;
  constructor(public payload: any) {}
}


export class ContractClearData implements Action {
  readonly type = ContractsActionTypes.ContractClearData;
}

export class ContractTabChanged implements Action {
  readonly type = ContractsActionTypes.ContractTabChanged;
  constructor(public payload: number) {}
}
export class ContractColdSelectedPageindex implements Action {
  readonly type = ContractsActionTypes.ContractSelectedColdPageIndex;
  constructor(
    public pageIndex: number,
    public pageSize: number,
    public sortColumn: string,
    public sortDirection: string,
    public scrollPosition: [number, number]
  ) {}
}
export class ContractHotSelectedPageindex implements Action {
  readonly type = ContractsActionTypes.ContractSelectedHotPageIndex;
  constructor(
    public pageIndex: number,
    public pageSize: number,
    public sortColumn: string,
    public sortDirection: string,
    public scrollPosition: [number, number]
  ) {}
}

export class HasContractAdditions implements Action {
  readonly type = ContractsActionTypes.HasContractAdditions;
  constructor(public payload: {
    meteringPointId: number,
    customerId: string,
    from: Date,
    to: Date,
    additions: AdditionCodes[]}) {}
}
export class HasContractAdditionsSuccess implements Action {
  readonly type = ContractsActionTypes.HasContractAdditionsSuccess;
  constructor(public payload: boolean) {}
}
export class HasContractAdditionsFail implements Action {
  readonly type = ContractsActionTypes.HasContractAdditionsFail;
  constructor(public payload: any) {}
}



// Agreement Addition e-sign
export class AgreementAdditionsEsignLoad implements Action{
  readonly type = ContractsActionTypes.AgreementAdditionEsignLoad;
  constructor(){}
}
export class AgreementAdditionsEsignLoadSuccess implements Action{
  readonly type = ContractsActionTypes.AgreementAdditionEsignLoadSuccess;
  constructor(public payload: AdditionEsignData[]){}
}
export class AgreementAdditionsEsignLoadFail implements Action{
  readonly type = ContractsActionTypes.AgreementAdditionEsignLoadFail;
  constructor(public payload: any){}
}

export type ContractsActions =
  | ContractLoad
  | ContractLoadSuccess
  | ContractLoadFail
  | ContractForDateIntervalLoad
  | ContractForDateIntervalLoadSuccess
  | ContractForDateIntervalLoadFail
  | ContractSetLoadedAsSelected
  | PrognosisContractSetLoadedAsSelected
  | SelectTabIndexContract
  | ContractsLoad
  | ContractsLoadSuccess
  | ContractsLoadFail
  | ContractsFilterSave
  | AgreementProductsLoad
  | AgreementProductsLoadSuccess
  | AgreementProductsLoadFail
  | ContractClearData
  | ContractTabChanged
  | ContractColdSelectedPageindex
  | ContractHotSelectedPageindex
  | HasContractAdditions
  | HasContractAdditionsSuccess
  | HasContractAdditionsFail
  | AgreementAdditionsEsignLoad
  | AgreementAdditionsEsignLoadSuccess
  | AgreementAdditionsEsignLoadFail
  | AgreementAdditionProductExclusionsLoad
  | AgreementAdditionProductExclusionsLoadSuccess 
  | AgreementAdditionProductExclusionsLoadFail

